import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/carousel";
import { ChevronRight } from "lucide-react";

type RoomGalleryProps = {
  gallery: string[]; // array of image URLs
  inModal?: boolean;
};

const RoomGallery = ({ gallery = [], inModal = false }: RoomGalleryProps) => {
  if (gallery.length === 0) return null;

  const appliedClassesContainer = inModal ? "min-h-32 2xl:min-h-64" : "min-h-128 max-h-128 2xl:max-h-196";
  const appliedClassesCarousel = inModal ? "max-h-128 2xl:max-h-196" : "min-h-128 max-h-196";
  const appliedClassesImage = inModal ? "h-32 2xl:h-64" : "h-128 2xl:h-196";

  return (
    <div
      className={`w-full ${appliedClassesContainer} bg-gray-200 flex items-center justify-center rounded-md shadow relative`}
    >
      {gallery.length > 1 && (
        <div className="absolute bottom-2 right-2 z-10 text-sm bg-white/80 p-0.5 px-2 rounded text-gray-700 flex">
          Slide me <ChevronRight className="w-5 h-5 animate-pulse" />
        </div>
      )}
      <Carousel opts={{ loop: true }} className={`w-full ${appliedClassesCarousel} rounded-lg overflow-hidden`}>
        <CarouselContent>
          {gallery.map((image, index) => (
            <CarouselItem key={index}>
              {/* <div className="relative h-34 w-64 aspect-video overflow-hidden rounded-lg mr-2"> */}
              <div
                className={`${appliedClassesImage} w-full`}
                style={{
                  backgroundImage: `url(${image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              />
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </div>
  );
};

export default RoomGallery;
